import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Optional, Output } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";

import { NzCheckboxComponent } from "ng-zorro-antd/checkbox";
import { Directionality } from "@angular/cdk/bidi";
import { FocusMonitor } from "@angular/cdk/a11y";
import { UiCheckboxWrapperComponent } from "@webapp/ui/checkbox/components/checkbox-wrapper/checkbox-wrapper.component";

@Component({
  selector: "[ui-checkbox]",
  exportAs: "uiCheckbox",
  templateUrl: "checkbox.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiCheckboxComponent),
      multi: true,
    },
  ],
})
export class UiCheckboxComponent extends NzCheckboxComponent {
  @Output("uiCheckedChange") public readonly nzCheckedChange = new EventEmitter<boolean>();
  @Input("uiValue") public nzValue: NzSafeAny | null = null;
  @Input("uiAutoFocus") @InputBoolean() public nzAutoFocus = false;
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiIndeterminate") @InputBoolean() public nzIndeterminate = false;
  @Input("uiChecked") @InputBoolean() public nzChecked = false;
  @Input("uiId") public nzId: string | null = null;

  constructor(
    uiElementRef: ElementRef<HTMLElement>,
    @Optional() uiCheckboxWrapperComponent: UiCheckboxWrapperComponent,
    uiCdr: ChangeDetectorRef,
    uiFocusMonitor: FocusMonitor,
    @Optional() uiDirectionality: Directionality
  ) {
    super(uiElementRef, uiCheckboxWrapperComponent, uiCdr, uiFocusMonitor, uiDirectionality);
  }
}
